// extracted by mini-css-extract-plugin
export default {"card":"ProjectListModal_card__Sn0KD","switchBtn":"ProjectListModal_switchBtn__lqEW-"};